export default __webpack_public_path__ + "static/media/lg-logo.46faef9a.png";